import uiCore = require("../core/uicore");
import entityCache = require("../core/entitycache");
import coreConstants = require("../core/core.constants");
import crewreportmenubar = require("../components/crewreportmenubar");
import { AuthServerProvider } from "../shared/auth/auth.service";
import { RequirementSections } from "../settings/requirementsections/requirement-sections.component";
import * as dataCore from "../core/datacore";

export class ReportsStateStrings {
    public static PersonTimeBalance = "reports.persontimebalance";
    public static PersonCV = "reports.personcv";
    public static PersonCompetences = "reports.personcompetences";
    public static PersonCompetenceList = "reports.personcompetencelist";
    public static PersonContactInfo = "reports.personcontactinfo";
    public static PersonNextOfKin = "reports.personnextofkin";

    public static WorkplaceTimeBalance = "reports.workplacetimebalance";
    public static WorkplaceRequirements = "reports.workplacerequirements";
    public static WorkplaceValidation = "reports.workplacevalidation";
    public static WorkplaceSchedule = "reports.workplaceschedule"
    public static WorkplaceScheduleTimetable = "reports.workplacescheduletimetable";
}

class SharedReportSettings {
    public static instance: SharedReportSettings = new SharedReportSettings();
    public Day: Date = dataCore.roundDay(new Date());
    public FromDate: Date = dataCore.firstDayOfMonth(new Date());
    public ToDate: Date = dataCore.lastDayOfMonth(new Date());
    public Person: Nema.Crew.Model.Person;
    public Persons: Nema.Crew.Model.Person[] = [];
    public Workplace: Nema.Crew.Model.Workplace;
    public ReportTitle: string = "";
}

class ReportsBase {

    public static BaseAngularDependencies: uiCore.IAngularDependencyId[] = [uiCore.ScopeDependency, uiCore.StateParamsDependency, uiCore.StateDependency, uiCore.MdDialogDependency, uiCore.AuthServerProvider];
    protected dataCache: entityCache.EntityCache;
    protected entitySetDictionary: entityCache.EntitySetDictionary;
    protected _locator: uiCore.DependencyLocator;
    protected authServerProvider: AuthServerProvider;


    public menuBarApi: crewreportmenubar.IReportMenuComponentApi = {
        title: "",
        selectedExportFormat: crewreportmenubar.pdfExportFormat,
        selectedZoomLevel: crewreportmenubar.defaultZoomLevel,
        onGetExportReportUrl: null,
        onRenderReport: null,
    }

    public shared: SharedReportSettings;
    public pdfViewerReportUrl: string;

    public addWorkGroup: (allPersons: Nema.Crew.Model.Person[], addedPersonIds: number[]) => void;

    constructor(dataDependencies: string[], onDataLoaded: () => void, component: uiCore.IComponentWithDescription, injected: any[]) {
        this.shared = SharedReportSettings.instance;
        this._locator = uiCore.DependencyLocator.Create(component, injected);

        this.authServerProvider = this._locator.getDependencyById("authServerProvider");

        this.dataCache = new entityCache.EntityCache(entityCache.CommonEntityManagers.EntityManager);
        var entitiesPromise = this.dataCache.getEntitySetsPromise(dataDependencies);
        var self = this;

        entitiesPromise.then(res => {
            this.entitySetDictionary = res;
            this.initializedata(res);
            if (onDataLoaded) {
                onDataLoaded();
            }
            self._locator.getScopeDependency().$apply();
        }).catch(_reason => {
        });

        this.menuBarApi.onRenderReport = () => {
            var args = this.getUrlArgs(crewreportmenubar.pdfExportFormat);
            if (this.formatUrlArgs(args)) {
                var jwtToken = this.authServerProvider.getToken();
                this.pdfViewerReportUrl = formatUrl(this.reportBaseUrl, args, jwtToken);
            };
        }

        this.menuBarApi.onGetExportReportUrl = (exportFormat) => {
            var args = this.getUrlArgs(exportFormat);
            if (this.formatUrlArgs(args)) {
                var jwtToken = this.authServerProvider.getToken();
                return formatUrl(this.reportBaseUrl, args, jwtToken);
            } else {
                return null;
            }
        }

        this.addWorkGroup = (allPersons: Nema.Crew.Model.Person[], addedPersonIds: number[]) => {
            for (let personId of addedPersonIds) {
                const person = allPersons.find(p => p.Id === personId);
                if (person && !this.shared.Persons.some(p => p.Id === person.Id)) {
                    this.shared.Persons.push(person);
                }
            }
        };
    }

    private getUrlArgs(exportFormat: crewreportmenubar.IExportFormat): IUrlArgs {
        return <IUrlArgs>{
            date: this.shared.Day,
            fromDate: this.shared.FromDate,
            toDate: this.shared.ToDate,
            format: exportFormat,
            other: []
        };
    }

    protected reportBaseUrl: string = null;
    protected formatUrlArgs: (args: IUrlArgs) => boolean = null;

    protected initializedata(_res: entityCache.EntitySetDictionary) {

    }

    public querySearchPerson(searchString: string): Nema.Crew.Model.Person[] {
        return <any[]>this.dataCache.searchActiveByName(entityCache.EntityTypeNames.Person, searchString);
    }

    public querySearchWorkplace(searchString: string): Nema.Crew.Model.Workplace[] {
        return <any[]>this.dataCache.searchActiveByName(entityCache.EntityTypeNames.Workplace, searchString);
    }

    public querySearcCompetenceRequirementCollection(searchString: string): Nema.Crew.Model.CompetenceRequirementCollection[] {
        return <any[]>this.dataCache.searchActiveByName(entityCache.EntityTypeNames.CompetenceRequirementCollection, searchString);
    }
}

// api/reportservice/Person/TimeBalance?pid=3&date=2012-01-31&fmt=PDF
interface IUrlArgsOther {
    id: string;
    value: any;
}

interface IUrlArgs {
    persons?: Nema.Crew.Model.Person[];
    workplaces?: Nema.Crew.Model.Workplace[];
    format: crewreportmenubar.IExportFormat;
    date: Date;
    fromDate?: Date;
    toDate?: Date;
    other: IUrlArgsOther[];

}

function addArg(id: string, value: any): string {
    return "&" + id + "=" + value;
}

function addArgs(id: string, values: any[]): string {
    var result = "";
    for (var i = 0; i < values.length; i++) result = result + addArg(id, values[i]);
    return result;
}

function formatUrlArgs(args: IUrlArgs): string {
    var result = "?date=" + args.date.getFullYear() + "-" + (args.date.getMonth() + 1) + "-" + args.date.getDate() + "&fmt=" + args.format.Code;
    if (args.persons) result += addArgs("pid", args.persons.map(it => it.Id));
    if (args.workplaces) result += addArgs("wid", args.workplaces.map(it => it.Id));
    for (var i = 0; i < args.other.length; i++) result = result + addArg(args.other[i].id, args.other[i].value);
    return result;
}

function formatUrl(reportUrl: string, args: IUrlArgs, jwtToken: string): string {
    if (jwtToken) {
        return coreConstants.ServiceConfig.webApiUrl + reportUrl + formatUrlArgs(args) + "&jwtToken=" + jwtToken;
    } else {
        return coreConstants.ServiceConfig.webApiUrl + reportUrl + formatUrlArgs(args);
    }
}

export class PersonTimeBalanceReport extends ReportsBase implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: "crewpersontimebalancereport",
        Url: "/persontimebalance",
        HeaderText: "Time Management &raquo; Person Balance",
        StateString: ReportsStateStrings.PersonTimeBalance,
        Template: require("./persontimebalance.html"),
        AngularDependencies: [].concat(ReportsBase.BaseAngularDependencies),
    }

    constructor(...args: any[]) {
        super([entityCache.EntityTypeNames.Person], () => {
        }, PersonTimeBalanceReport, args);

        this.reportBaseUrl = "reportservice/Person/TimeBalance";
        this.formatUrlArgs = (args) => {
            if (!this.shared.Person) {
                return false;
            }
            args.persons = [this.shared.Person];
            return true;
        };
    }
}

export class PersonCVReport extends ReportsBase implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: "crewpersoncvreport",
        Url: "/personcv",
        HeaderText: "Resources &raquo; CV",
        StateString: ReportsStateStrings.PersonCV,
        Template: require("./personcv.html"),
        AngularDependencies: [].concat(ReportsBase.BaseAngularDependencies),
    }

    constructor(...args: any[]) {
        super([entityCache.EntityTypeNames.Person], () => {
        }, PersonCVReport, args);

        this.reportBaseUrl = "reportservice/Person/CV";
        this.formatUrlArgs = (args) => {
            if (!this.shared.Person) {
                return false;
            }
            args.persons = [this.shared.Person];
            return true;
        };
    }
}

export class PersonContactInfoReport extends ReportsBase implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: "crewpersoncontactinforeport",
        Url: "/personcontactinfo",
        HeaderText: "Resources &raquo; Contact Info",
        StateString: ReportsStateStrings.PersonContactInfo,
        Template: require("./personcontactinfo.html"),
        AngularDependencies: [].concat(ReportsBase.BaseAngularDependencies),
    }

    public allPersons: Nema.Crew.Model.Person[];
    public allWorkGroups: Nema.Crew.Model.WorkGroup[];

    public onWorkGroupAdded: (addedPersonIds: number[]) => void;

    constructor(...args: any[]) {
        super([entityCache.EntityTypeNames.Person, entityCache.EntityTypeNames.WorkGroup, entityCache.EntityTypeNames.WorkGroupPerson], () => {
            this.allPersons = <any>this.entitySetDictionary[entityCache.EntityTypeNames.Person];
            this.allWorkGroups = <any>this.entitySetDictionary[entityCache.EntityTypeNames.WorkGroup];
        }, PersonContactInfoReport, args);

        this.reportBaseUrl = "reportservice/Person/ContactInfo";
        this.formatUrlArgs = (args) => {
            if (!this.shared.Persons) {
                return false;
            }
            args.persons = this.shared.Persons;
            return true;
        };

        this.onWorkGroupAdded = (addedPersonIds: number[]) => {
            this.addWorkGroup(this.allPersons, addedPersonIds);
        };
    }
}

export class PersonNextOfKinReport extends ReportsBase implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: "crewpersonnextofkinreport",
        Url: "/personnextofkin",
        HeaderText: "Resources &raquo; Next of Kin",
        StateString: ReportsStateStrings.PersonNextOfKin,
        Template: require("./personcontactinfo.html"),
        AngularDependencies: [].concat(ReportsBase.BaseAngularDependencies),
    }

    public allPersons: Nema.Crew.Model.Person[];
    public allWorkGroups: Nema.Crew.Model.WorkGroup[];

    public onWorkGroupAdded: (addedPersonIds: number[]) => void;

    constructor(...args: any[]) {
        super([entityCache.EntityTypeNames.Person, entityCache.EntityTypeNames.WorkGroup, entityCache.EntityTypeNames.WorkGroupPerson], () => {
            this.allPersons = <any>this.entitySetDictionary[entityCache.EntityTypeNames.Person];
            this.allWorkGroups = <any>this.entitySetDictionary[entityCache.EntityTypeNames.WorkGroup];
        }, PersonNextOfKinReport, args);

        this.reportBaseUrl = "reportservice/Person/NextOfKin";
        this.formatUrlArgs = (args) => {
            if (!this.shared.Persons) {
                return false;
            }
            args.persons = this.shared.Persons;
            return true;
        };

        this.onWorkGroupAdded = (addedPersonIds: number[]) => {
            this.addWorkGroup(this.allPersons, addedPersonIds);
        };
    }
}

interface ICompetenceValiditySelection {
    valid: boolean;
    warning: boolean;
    invalid: boolean;
    expired: boolean;
    future: boolean;
    indicators: boolean;
}

var _commonValiditySelection: ICompetenceValiditySelection = {
    valid: true,
    warning: true,
    invalid: true,
    expired: true,
    future: true,
    indicators: true
}

export class PersonCompetencesReport extends ReportsBase implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: "crewpersoncompetencesreport",
        Url: "/personcompetences",
        HeaderText: "Resources &raquo; Competences",
        StateString: ReportsStateStrings.PersonCompetences,
        Template: require("./personcompetences.html"),
        AngularDependencies: [].concat(ReportsBase.BaseAngularDependencies),
    }

    public allPersons: Nema.Crew.Model.Person[];
    public allWorkGroups: Nema.Crew.Model.WorkGroup[];

    public validitySelection: ICompetenceValiditySelection;

    public onWorkGroupAdded: (addedPersonIds: number[]) => void;

    constructor(...args: any[]) {
        super([entityCache.EntityTypeNames.Person, entityCache.EntityTypeNames.WorkGroup, entityCache.EntityTypeNames.WorkGroupPerson], () => {
            this.allPersons = <any>this.entitySetDictionary[entityCache.EntityTypeNames.Person];
            this.allWorkGroups = <any>this.entitySetDictionary[entityCache.EntityTypeNames.WorkGroup];
        }, PersonCompetencesReport, args);

        this.validitySelection = _commonValiditySelection;
        this.reportBaseUrl = "reportservice/Person/Competences";
        this.formatUrlArgs = (args) => {
            if (!this.shared.Persons) {
                return false;
            }
            args.persons = this.shared.Persons;
            args.other.push({ id: "valid", value: this.validitySelection.valid });
            args.other.push({ id: "warning", value: this.validitySelection.warning });
            args.other.push({ id: "invalid", value: this.validitySelection.invalid });
            args.other.push({ id: "expired", value: this.validitySelection.expired });
            args.other.push({ id: "future", value: this.validitySelection.future });
            args.other.push({ id: "indicators", value: this.validitySelection.indicators });

            return true;
        };

        this.onWorkGroupAdded = (addedPersonIds: number[]) => {
            this.addWorkGroup(this.allPersons, addedPersonIds);
        };
    }
}

export class PersonCompetenceListReport extends ReportsBase implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: "crewpersoncompetencelistreport",
        Url: "/personcompetencelist",
        HeaderText: "Resources &raquo; Competence List",
        StateString: ReportsStateStrings.PersonCompetenceList,
        Template: require("./personcompetences.html"),
        AngularDependencies: [].concat(ReportsBase.BaseAngularDependencies),
    }

    public allPersons: Nema.Crew.Model.Person[];
    public allWorkGroups: Nema.Crew.Model.WorkGroup[];

    public validitySelection: ICompetenceValiditySelection;

    public onWorkGroupAdded: (addedPersonIds: number[]) => void;

    constructor(...args: any[]) {
        super([entityCache.EntityTypeNames.Person, entityCache.EntityTypeNames.WorkGroup, entityCache.EntityTypeNames.WorkGroupPerson], () => {
            this.allPersons = <any>this.entitySetDictionary[entityCache.EntityTypeNames.Person];
            this.allWorkGroups = <any>this.entitySetDictionary[entityCache.EntityTypeNames.WorkGroup];
        }, PersonCompetenceListReport, args);

        this.validitySelection = _commonValiditySelection;
        this.reportBaseUrl = "reportservice/Person/CompetenceList";
        this.formatUrlArgs = (args) => {
            if (!this.shared.Persons) {
                return false;
            }
            args.persons = this.shared.Persons;
            args.other.push({ id: "valid", value: this.validitySelection.valid });
            args.other.push({ id: "warning", value: this.validitySelection.warning });
            args.other.push({ id: "invalid", value: this.validitySelection.invalid });
            args.other.push({ id: "expired", value: this.validitySelection.expired });
            args.other.push({ id: "future", value: this.validitySelection.future });
            args.other.push({ id: "indicators", value: this.validitySelection.indicators });

            return true;
        };

        this.onWorkGroupAdded = (addedPersonIds: number[]) => {
            this.addWorkGroup(this.allPersons, addedPersonIds);
        };
    }
}

export class WorkplaceTimeBalanceReport extends ReportsBase implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: "crewworkplacetimebalancereport",
        Url: "/workplacetimebalance",
        HeaderText: "Reports &raquo; Workplace Time Balance",
        StateString: ReportsStateStrings.WorkplaceTimeBalance,
        Template: require("./workplacetimebalance.html"),
        AngularDependencies: [].concat(ReportsBase.BaseAngularDependencies),
    }

    public showDeviations: boolean = true;

    constructor(...args: any[]) {
        super([entityCache.EntityTypeNames.Workplace], () => {
        }, WorkplaceTimeBalanceReport, args);

        this.reportBaseUrl = "reportservice/Workplace/TimeBalance";
        this.formatUrlArgs = (args) => {
            if (!this.shared.Workplace) {
                return false;
            }
            args.workplaces = [this.shared.Workplace];
            args.other.push({ id: "devs", value: this.showDeviations });
            return true;
        };
    }
}

export class WorkplaceRequirementsReport extends ReportsBase implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: "crewworkplacerequirementsreport",
        Url: "/workplacerequirements",
        HeaderText: "Compliance &raquo; Workplace Requirements",
        StateString: ReportsStateStrings.WorkplaceRequirements,
        Template: require("./workplacerequirements.html"),
        AngularDependencies: [].concat(ReportsBase.BaseAngularDependencies),
    }

    constructor(...args: any[]) {
        super([entityCache.EntityTypeNames.Workplace], () => {
        }, WorkplaceRequirementsReport, args);

        this.reportBaseUrl = "reportservice/Workplace/Requirements";
        this.formatUrlArgs = (args) => {
            if (!this.shared.Workplace) {
                return false;
            }
            args.workplaces = [this.shared.Workplace];
            return true;
        };
    }
}

export class WorkplaceValidationReport extends ReportsBase implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: "crewworkplacevalidationreport",
        Url: "/workplacevalidation",
        HeaderText: "Compliance &raquo; Workplace Validation",
        StateString: ReportsStateStrings.WorkplaceValidation,
        Template: require("./workplacevalidation.html"),
        AngularDependencies: [].concat(ReportsBase.BaseAngularDependencies),
    }

    public CompetenceRequirementCollection: Nema.Crew.Model.CompetenceRequirementCollection;

    public CompetenceRequirementCollectionEntityName: string = RequirementSections.entityName;

    constructor(...args: any[]) {
        super([entityCache.EntityTypeNames.Workplace, entityCache.EntityTypeNames.CompetenceRequirementCollection], () => {
        }, WorkplaceValidationReport, args);

        this.reportBaseUrl = "reportservice/Workplace/Validation";
        this.formatUrlArgs = (args) => {
            if (!this.shared.Workplace) {
                return false;
            }
            args.workplaces = [this.shared.Workplace];
            if (this.CompetenceRequirementCollection) args.other.push({ id: "rcid", value: this.CompetenceRequirementCollection.Id })
            return true;
        };
    }
}

export class WorkplaceScheduleReport extends ReportsBase implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: "crewworkplaceschedulereport",
        Url: "/workplaceschedule",
        HeaderText: "Time Management &raquo; Crew Schedule",
        StateString: ReportsStateStrings.WorkplaceSchedule,
        Template: require("./workplaceschedule.html"),
        AngularDependencies: [].concat(ReportsBase.BaseAngularDependencies),
    }

    constructor(...args: any[]) {
        super([entityCache.EntityTypeNames.Workplace], () => {
        }, WorkplaceScheduleReport, args);

        this.reportBaseUrl = "reportservice/Workplace/Schedule";
        this.formatUrlArgs = (args) => {
            if (!this.shared.Workplace) {
                return false;
            }
            args.workplaces = [this.shared.Workplace];
            args.other.push({ id: "fromDate", value: + args.fromDate.getFullYear() + "-" + (args.fromDate.getMonth() + 1) + "-" + args.fromDate.getDate() });
            args.other.push({ id: "toDate", value: + args.toDate.getFullYear() + "-" + (args.toDate.getMonth() + 1) + "-" + args.toDate.getDate() });
            return true;
        };
    }
}

export class WorkplaceScheduleTimetableReport extends ReportsBase implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: "crewworkplacescheduletimetablereport",
        Url: "/workplacescheduletimetable",
        HeaderText: "Time Management &raquo; Workplace Balance",
        StateString: ReportsStateStrings.WorkplaceScheduleTimetable,
        Template: require("./workplacescheduletimetable.html"),
        AngularDependencies: [].concat(ReportsBase.BaseAngularDependencies),
    }

    public showDeviations: boolean = true;
    public showBalance: boolean = true;

    constructor(...args: any[]) {
        super([entityCache.EntityTypeNames.Workplace], () => {
        }, WorkplaceScheduleTimetableReport, args);

        this.reportBaseUrl = "reportservice/Workplace/ScheduleTimetable";
        this.formatUrlArgs = (args) => {
            if (!this.shared.Workplace) {
                return false;
            }
            args.workplaces = [this.shared.Workplace];
            args.other.push({ id: "devs", value: this.showDeviations });
            args.other.push({ id: "showBalance", value: this.showBalance });
            return true;
        };
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/reports/reportscommon.ts